module.exports = __webpack_public_path__ + "static/media/parts_04.7d3e2bab.svg";